module.exports = __webpack_public_path__ + "img/clogo.13a5aaf4.png";